export default __webpack_public_path__ + "static/media/03_motor_Extras.2b696bef.svg";